module.exports = __webpack_public_path__ + "static/media/Assistinmedical.a82dde46.svg";